module.exports = __webpack_public_path__ + "media/images/eyeless-doggo-52ca8d6cfb1f680a8fc734c439c1e44d.jpeg";